export default __webpack_public_path__ + "assets/images/diamonds.e85eb8b1fd7b4bc86fbed2cbdbc3dec0.png";